import { render, staticRenderFns } from "./PersonalAreaPdfBody.vue?vue&type=template&id=7742e53e&scoped=true&"
import script from "./PersonalAreaPdfBody.vue?vue&type=script&lang=js&"
export * from "./PersonalAreaPdfBody.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAreaPdfBody.vue?vue&type=style&index=0&id=7742e53e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7742e53e",
  null
  
)

export default component.exports